export enum ClientTypes {
    STREET = 'street',
    PLACES = 'places'
}

export const DEV_ENV = 'DEV'
export const PROD_ENV = 'PROD'
export const TIKTOK_URL = 'https://www.tiktok.com/@remmi.ai'
export const INSTAGRAM_URL = 'https://www.instagram.com/remmi.ai'
export const LINKEDIN_URL = 'https://www.linkedin.com/company/remmi'
export const TWITTER_URL = 'https://twitter.com/remmiai'
